// 認証秘密はCookieのみ。移行前のJWTは読み取らずに削除する。
export function clearLegacyAuth() {
  try { localStorage.removeItem('jwt') } catch (_) { /* 保存が禁止された環境 */ }
  try { sessionStorage.removeItem('jwt') } catch (_) { /* 保存が禁止された環境 */ }
}

clearLegacyAuth()
let pendingCsrf = null

// 同時開始した要求は共有し、ログイン・別タブでの切替後は取り直す。
export async function csrfHeaders() {
  clearLegacyAuth()
  if (!pendingCsrf) {
    pendingCsrf = fetch('/webapi/client/session/csrf.json', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {'Accept': 'application/json'}
    }).then(async response => {
      if (!response.ok) throw new Error('画面を再読み込みしてください。')
      const data = await response.json()
      if (!data.csrf_token) throw new Error('画面を再読み込みしてください。')
      return {'X-CSRF-Token': data.csrf_token}
    })
  }
  try {
    return await pendingCsrf
  } finally {
    pendingCsrf = null
  }
}
